module.exports = __webpack_public_path__ + "img/385264_A1D3E2_86ADC1_6E94A8-256px.4194cb53.png";